import Hero from 'components/ckan/Herov2';
import Highlight from 'components/solutions/Highlight.jsx'
import ValuePropositions from 'components/ckan/ValuePropositions.jsx'
import SocialProof from 'components/ckan/SocialProof';
import Features from 'components/ckan/Features.jsx';
import MoreFeatures from './MoreFeatures';
import CaseStudiesSection from 'components/solutions/CaseStudiesSection';
import Link from 'next/link';

export default function DataStrategy({casestudies}) {
  const values= [
    {
      title: "Planning",
      text: "We help you plan properly so you don’t waste time on dead-end projects or building for the wrong use cases.",
    },
      {
      title: "360 advice",
      text: "Data isn’t created in a vacuum, which is why we offer expert advice on the legal and social context in which data solutions are created.",
    },
      {
      title: "Pragmatism",
      text: "Technologists and entrepreneurs in one, we don’t just consult – we implement, too.",
    },
  ]

  const features = [
    {
      title: 'Training sessions',
      text: 'We can get your team up to speed on best data practices, data publishing, and more.',
      icon: "/assets/icons/presentation-4.json"
    },
    { 
      title: 'In-house consulting', 
      text: 'For big projects, we&apos;ll come to you to plan your strategy in person.',
      icon: "/assets/icons/conference.json"
    },
    {
      title: 'Technical analysis',
      text: 'We carry out technical analysis to work out where you are now and identify existing systems.',
      icon: "/assets/icons/magnify.json"
    },
    {
      title: 'Stakeholder interviews',
      text: 'We’ll speak to those who have a stake in your organisation to make sure you have a strategy that works for everyone.',
      icon: "/assets/icons/presentation.json"
    },
    {
      title: 'Roadmaps',
      text: 'We’ll plan out yearly roadmaps so you can best allocate resources and keep an eye on the bigger picture.',
      icon: "/assets/icons/flow-chart.json"
    },
      {
      title: 'Data licensing',
      text: 'We are experts in data licensing and will make sure you are publishing compliant data.',
      icon: "/assets/icons/verified.json"
    },
  ]

  return (
    <section className="bg-homeExpert bg-no-repeat bypass-filter bg-strategyPosition !overflow-x-hidden"
    >
      <section>
        <Hero topTitle="Data Strategy" title="Design your data future. Harness technology before it harnesses you." subtitle="We’ve been building data solutions for almost 20 years. Consider your legal, social, and technical needs covered." />
      </section>

      <section className='pt-8'>
        <SocialProof />
      </section>
      
      <section className=' relative w-screen max-w-screen overflow-hidden lg:flex-row bg-gradient-to-b from-transparent to-[#F7F8F9]'>
          <Highlight subtitle="EMPOWER YOUR DATA JOURNEY " topTitle="Discover the difference a human-centric, customized data strategy can make"
            text="In a world where data is the lifeblood of businesses, finding your way through the maze of information can be overwhelming. A tailored data strategy is your compass, guiding you toward valuable insights and tangible outcomes. At Datopian, we combine cutting-edge technology with deep industry expertise to help you harness the power of your data. Discover the difference a human-centric, customized data strategy can make, and start your journey to data-driven success."
        />
        <Highlight subtitle="HARNESS THE POWER OF DATA" topTitle="20 years of experience, a dash of wit, and a whole lot of data know-how"
          text="Imagine having access to a dream team that's part data whisperer, part strategic visionary, and completely committed to your success. It's time to harness the power of data, unlock your business potential, and embark on a data strategy adventure that's anything but ordinary!"
          reverse
        />
        <Highlight subtitle="ELEVATE YOUR BUSINESS" topTitle="Great strategies come from great minds"
            text="Our expert team will lead you through data discovery, analysis, and optimization, providing essential insights to outpace the competition. Utilize our proficiency in data governance, integration, and analytics to uncover opportunities and fuel growth. Begin your data strategy journey with Datopian and experience the impact of informed decisions"
           />
      </section>

      <section className='mt-16 '>
        <ValuePropositions topTitle="It all starts with the right strategy" title="With the right strategy in place, you'll be empowered to make informed decisions, streamline processes, and drive innovation, propelling your business to new heights of success."
          valuePropositions={values} />
      </section>

      <section className='mt-16'>
       <Features topTitle="Tame your data chaos" title="Our expert team can help you overcome the complexity of data management, transforming disorganized data into actionable insights that nurture growth and innovation throughout your organization." featuredItems={features}/>
      </section>

      <section className='mt-16'>
        <MoreFeatures />
      </section>

      <section>
        <CaseStudiesSection blogs={casestudies} subtitle="DATA STRATEGY" catalog="data" />
      </section>

      <section className='bg-[#F7F8F9] py-20 relative w-screen max-w-screen overflow-hidden' tabIndex={0}>
        <h3 className='text-center mx-auto medium-title font-["Inter"]  text-maingray'>Data Strategy can fuel your growth. Let us show you how.</h3>
        <p className='text-center font-["Inter"] text-maingray mt-4 px-8 sm:px-0 mx-auto xl:max-w-4xl lg:max-w-3xl md:max-w-2xl max-w-sm'>Unlock your business potential with our expertise. Join thousands of happy customers.</p>
        <div className='flex flex-col  sm:flex-row mt-8 gap-y-8 sm:gap-x-8 w-full justify-center px-8 sm:px-0 mx-auto xl:max-w-4xl lg:max-w-3xl md:max-w-2xl max-w-sm'>
         <div className='btn-primary'><Link href="/contact">Email us</Link></div>
        <div className='btn-primary'><Link href="https://calendar.app.google/LT4acVdKn3Cxm2MXA" target="_blank">Schedule a free call</Link></div>
        </div>
      </section>

    </section>
  );
}
